module.exports = __webpack_public_path__ + "img/GyöngyLaky-ChangYeonsoon-KiyomiIwata.2a25cab9.jpg";